import React from 'react';
import './LegalPages.css';

const TermsConditions = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Terms & Conditions</h1>
        
        <div className="legal-content">
          <p>
            By accessing the Unity Trademark website (referred to as the "Site"), you acknowledge and 
            accept the terms and conditions outlined herein, forming an agreement between you and Unity 
            Trademark (referred to as "we," "us," or "our"). This agreement also incorporates our Privacy 
            Policy as if fully stated here. If you do not agree with these terms, please refrain from using 
            the Site. We offer general information related to trademarks and provide a platform where you 
            can prepare and file trademarks. THIS AGREEMENT INCLUDES A MANDATORY ARBITRATION CLAUSE 
            GOVERNED BY THE FEDERAL ARBITRATION ACT, AND A WAIVER OF CLASS ACTIONS.
          </p>

          <h2>Conditions for Use of the Site</h2>
          <p>
            Your access to and use of the Site is contingent upon your acceptance and adherence to these 
            terms. By using the Site, you agree that you:
          </p>
          <ul>
            <li>Will comply with these Terms of Service;</li>
            <li>Are 18 years of age or older;</li>
            <li>Will not use the Site in any way that violates U.S. laws, including its export and re-export regulations;</li>
            <li>Will not copy or distribute any content from the Site without our prior written consent;</li>
            <li>Will provide accurate details when registering, submitting content, or interacting with the Site;</li>
            <li>Will not permit others to use the Site under your user credentials;</li>
            <li>Are fully responsible for all activity under your account and user credentials;</li>
            <li>Will not use the Site for commercial purposes other than those expressly stated;</li>
            <li>Will not use the Site to collect personal information about others or solicit users or advertisers;</li>
            <li>
              Are solely responsible for any content you submit to the Site, ensuring you have the rights 
              or licenses to do so, and will not upload any materials infringing on others' copyrights or 
              proprietary rights;
            </li>
            <li>
              Grant us and other users a non-exclusive license to use, display, reproduce, distribute, or 
              create derivative works from your submitted materials; and
            </li>
            <li>Agree that we may remove any of your content and suspend or terminate your account, with or without prior notice.</li>
          </ul>

          <h2>Your Content</h2>
          <p>
            We reserve the right to publish any content you provide (referred to as "User-Generated Content" 
            or "UGC"). You agree not to upload or use any UGC that:
          </p>
          <ul>
            <li>Violates the intellectual property rights of others, including copyright, trademarks, or trade secrets;</li>
            <li>Infringes on privacy or publicity rights of any third party;</li>
            <li>Is unlawful, inaccurate, defamatory, discriminatory, obscene, or harassing;</li>
            <li>Encourages criminal activity or civil liability;</li>
            <li>Is deemed inappropriate by us, in our sole discretion; or</li>
            <li>Could harm our company, affiliates, or partners.</li>
          </ul>
          <p>
            We are not obligated to remove UGC violating these terms, but we reserve the right to do so at 
            our discretion, and may take further action such as account termination. We are not liable for 
            any harm caused by UGC.
          </p>

          <h2>Your Behavior</h2>
          <p>By using the Site, you agree not to:</p>
          <ul>
            <li>Engage in or promote illegal activities;</li>
            <li>Attempt to reverse engineer or disrupt the Site's functionality;</li>
            <li>Attempt to access restricted areas of the Site;</li>
            <li>Use the Site for unsolicited email campaigns or spam;</li>
            <li>Use automated tools to scrape or collect data from the Site;</li>
            <li>Interfere with the proper functioning of the Site;</li>
            <li>Impersonate another user.</li>
          </ul>

          <h2>Links to Third-Party Sites</h2>
          <p>
            Our Site may contain links to third-party websites not controlled by us. We assume no 
            responsibility for the content or practices of these external sites. Linking to these sites 
            does not imply endorsement by us.
          </p>

          <h2>Termination</h2>
          <p>
            We reserve the right to modify or discontinue the Site or any services provided without prior 
            notice. Additionally, we may terminate this agreement for any reason, with or without notice. 
            If we terminate your access due to violations of these terms, you will immediately lose access 
            to the Site. The clauses related to warranties, liabilities, indemnity, dispute resolution, and 
            your content will survive the termination of this agreement.
          </p>

          <h2>Displaying Data and Search Features</h2>
          <p>
            We may use official government records and display them on the Site. While we strive to ensure 
            accuracy, we do not guarantee that the information is up-to-date or error-free.
          </p>

          <h2>Calendar Reminders</h2>
          <p>
            We may offer reminders about specific trademark deadlines as part of our services. These 
            reminders are for general informational purposes and may not apply to your unique circumstances. 
            We recommend consulting with a licensed attorney regarding deadlines specific to your situation.
          </p>

          <h2>Credit Card Information</h2>
          <p>
            We may store your credit card details only for the purpose of paying the filing fees associated 
            with your order, provided you approve the application and are aware of the costs involved.
          </p>

          <h2>Search Services</h2>
          <p>
            If you use our search services, we employ reasonable methods to identify potential matches to the 
            trademarks you wish to use. However, we cannot guarantee that your trademark will be approved by 
            the USPTO or that it will not face challenges, even with our search services. There are cases 
            where automated searches may not identify conflicts that could result in rejection by the USPTO. 
            Similarly, for common law mark searches, while we use commercially reasonable methods to find 
            potential matches, we cannot guarantee that all common law claims will be identified.
          </p>

          <h2>Trademark Search Scope</h2>
          <p>
            Our Unity Trademark federal search reviews the USPTO database and includes direct matches, 
            phonetic similarities, or visual design similarities. Our Unity Trademark federal, state, and 
            common law search extends to all 50 states, a business registry, and domain name databases, 
            including matches in phonetics, design, or translation. Our Unity Trademark global search 
            includes the USPTO database, state databases, business registries, domain name databases, the 
            WIPO database, and the European Community database, focusing on direct matches, phonetic 
            similarities, or visual design likenesses.
          </p>

          <h2>Trademark Monitoring Services</h2>
          <p>
            Our trademark monitoring service reviews the filing of new applications that are direct matches, 
            phonetically similar, similar in terms of translation, or appearance by way of design to your 
            marks as published in the Official Gazette of the USPTO and Unity Trademark.
          </p>

          <h2>Subscription and Auto-Renewals</h2>
          <p>
            If you signed up for one or more subscription services through the Website, these additional 
            terms apply. Your license to the Services is valid during the period your subscription remains 
            in good standing and there are no outstanding subscription payments (hereinafter "Subscription Term"). 
            To keep your Subscription Term valid and in force, you must pay all charges to your account 
            relating to your subscriptions, including applicable taxes and fees. Unless otherwise provided, 
            your Subscription Term is on an automatic renewal and you will be required to pay, through the 
            credit card provided by you, for the next applicable Subscription Term at the beginning of the 
            Subscription Term period.
          </p>
          <p>
            These charges are applied regardless of whether you continue to use the Services during the 
            Subscription Term. YOU ARE RESPONSIBLE FOR SUBSCRIPTION FEES UNTIL YOU CANCEL YOUR SUBSCRIPTION 
            OR IT IS OTHERWISE TERMINATED. If your Subscription Term is month to month and your purchase date 
            is on the 29th through 31st day of any month, your renewal date will fall on the last day of the 
            month for any succeeding months with fewer days.
          </p>

          <h2>New Services/Features</h2>
          <p>
            From time to time, we may offer new services and/or features through the website (including, the 
            release of new tools and resources). Such new features and/or services shall also be subject to 
            these Terms of Service.
          </p>

          <h2>Disclaimers of Warranty and Limitations of Liability</h2>
          <p>
            We provide the Website and the related services "as is", "where is", and "as available." We make 
            no express and/or implied warranties or guarantees about the Website, the goods and services 
            described thereon or the Advertisers. TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE AND OUR OFFICERS, 
            DIRECTORS, AGENTS, VENDORS, AND THE MERCHANTS WHO ADVERTISE WITH US DISCLAIM ANY AND ALL EXPRESS 
            OR IMPLIED WARRANTIES THAT THE WEBSITE AND SERVICES ARE MERCHANTABLE, OF SATISFACTORY QUALITY, 
            ACCURATE, TIMELY OR FIT FOR A PARTICULAR PURPOSE OR NEED.
          </p>
          <p>
            WE IN NO WAY GUARANTEE THAT WE WILL MEET YOUR REQUIREMENTS, IS ERROR-FREE, ACCURATE, RELIABLE, 
            WITHOUT INTERRUPTION OR AVAILABLE AT ALL TIMES. WE MAKE NO GUARANTEE THAT YOU WILL BE ABLE TO 
            ACCESS OR USE THE WEBSITE AT TIMES OR LOCATIONS OF YOUR CHOOSING. YOUR SOLE AND EXCLUSIVE REMEDY 
            FOR ANY DISPUTE OR CLAIM WITH US IS TO CEASE USE OF THE WEBSITE.
          </p>

          <h2>Indemnity</h2>
          <p>
            You agree to defend, indemnify and hold harmless us, our officers, directors, representatives, 
            employees and agents and all of our parent companies, affiliates, related companies and their 
            officers, directors, representatives, employees and agents from and against any and all claims, 
            damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited 
            to reasonable attorney's fees) arising from: (i) your violation of any term of these Terms of 
            Service; (ii) your violation of any third party right, including without limitation any copyright, 
            property, privacy right, or any and all intangible or intellectual property rights; or (iii) any 
            claim that any of your UGC causes damage to a third party.
          </p>

          <h2>Dispute Resolution</h2>
          <p>
            For the purposes of this Section, references to "Unity Trademark," "you," and "us" include our 
            respective subsidiaries, affiliates, agents, employees, business partners, predecessors in interest, 
            successors, and assigns, as well as all authorized or unauthorized users or beneficiaries of 
            services or products under these Terms or any prior agreements between us.
          </p>

          <h2>Arbitration</h2>
          <p>
            Any Dispute shall be FINALLY and EXCLUSIVELY resolved by binding individual arbitration conducted 
            by the American Arbitration Association ("AAA") under its Consumer Arbitration Rules. This 
            arbitration agreement is made pursuant to a transaction involving interstate commerce, and shall 
            be governed by the Federal Arbitration Act (9 U.S.C. 1-16). ARBITRATION OF YOUR CLAIM IS MANDATORY 
            AND BINDING. NEITHER PARTY WILL HAVE THE RIGHT TO LITIGATE THAT CLAIM THROUGH A COURT.
          </p>

          <h2>Right to Opt-Out</h2>
          <p>
            You may opt-out of arbitration by notifying us of your decision to reject the arbitration clause 
            in writing. You must notify us within 30 days of accepting this Agreement. Failure to do so will 
            make this Agreement binding on you.
          </p>

          <h2>Copyright Notice</h2>
          <p>
            If you believe your copyright has been violated, please send a notification in accordance with 
            the Digital Millennium Copyright Act (17 U.S.C. § 512(c)(3)) to our designated copyright agent, 
            with the subject line: "Copyright Notice."
          </p>

          <h2>Refund Policy</h2>
          <p>
            All packages include attorney-conducted searches and are non-refundable. Once a search and 
            clearance report is issued, payment will be automatically processed within 24-48 hours if we do 
            not receive a response from you via email or phone. The payment will be transferred to the USPTO 
            (United States Patent and Trademark Office) through the attorney.
          </p>

          <h2>Authorization</h2>
          <p>
            By submitting an order, you authorize us to receive correspondence from the USPTO related to your 
            trademarks alongside you. While you can revoke this at any time, including us in communications 
            helps us assist you better and may be necessary for services such as monitoring and scheduling.
          </p>

          <h2>Modifications to the Agreement</h2>
          <p>
            We retain the right to modify or discontinue any of these terms and/or the Privacy Policy at any 
            time, as we deem necessary. Changes may include the introduction of new fees or charges. We may, 
            but are not required to, notify you of significant changes through email or by posting a notice 
            on the Website. Any modifications will be effective when we send an email notice to you or post 
            the changes on the Website, whichever comes first.
          </p>

          <h2>Contact Information</h2>
          <div className="contact-info">
            <p><strong>Company:</strong> Unity Trademark</p>
            <p><strong>Address:</strong> 2029 Century Park E, Los Angeles, CA 90067, USA</p>
            <p><strong>Phone:</strong> +1 (213) 266-5334</p>
            <p><strong>Website:</strong> unitytrademark.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
